var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-1 mb-lg-2 pl-lg-3" }, [
    _c(
      "form",
      {
        attrs: { id: "form--product-search" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.searchProducts.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { staticClass: "input-wrapper" }, [
          _c("i", {
            staticClass: "fa fa-search",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search",
              },
            ],
            attrs: { type: "search", value: "" },
            domProps: { value: _vm.search },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.search = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "btn--orange",
          class: { disabled: _vm.isDisabled },
          attrs: { type: "submit", disabled: _vm.isDisabled },
          domProps: { value: _vm.buttonText },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }